import FieldPopover from "../../popover/popover"
import FieldTimeSpent_Popover from "./components/popover/popover"
import FieldTimeReported_InlineValueNotEmpty from "./components/inline-edit/value-not-empty"
import FieldTimeSpent_View from "./render/view"
import FieldTimeSpent_ViewSmall from "./render/view-small"
import FieldConfig from "../../../proto/field-config"
import {GROUP_MISC} from "../../../../gd/const/fields/field2-groups"
import FieldTimeReported_FormValueNoteEmpty from "./components/form/value-not-empty"
import minutesToHoursMinutesString from "../../../../gd/format/minutes-to-hm-string"
import FieldTimeSpent_FormElement from "./render/form-element"
import FieldTimeReported_PickerValueNotEmpty from "./components/picker/value-not-empty"
import FieldTimeSpent_Picker from "./render/picker"
import FieldTimeReported_InlineValueEmpty from "./components/inline-edit/value-empty"
import FieldTimeSpent_ConditionForm from "./render/condition"
import {FIELD_CONDITIONS_NUMBER, FieldNumber_filterFunc} from "../../../conditions/number"
import {FieldFilterType} from "../../../proto/types"

export default class FieldTimeSpent extends FieldPopover {

    FIELD_DEFAULT_WIDTH = 100

    public startMomentFieldId       : string
    public endMomentFieldId         : string
    public placeholderValueExample  : string    = "Enter time duration e.g. 3h 20m"
    public hasStartEnd              : boolean   = true  // if true - popover will display start/end Moment for time duration
    public presetMinutes?           : Option[]
    public presetHours?             : Option[]
    public canBeBillable            : boolean   = false // if true will display isBillable toggle in popover if other criaterias true

    constructor(config:FieldConfig) {
        super(config);

        this.startMomentFieldId = _.get(config.options,'startMomentFieldId','startMoment')
        this.endMomentFieldId   = _.get(config.options,'startMomentFieldId','endMoment')

        this.typeLabel          = "Time reported"
        this.filterType         = FieldFilterType.NUMBER
        this.typeGroup          = GROUP_MISC
        this.typeDescription    = "Time reported selector"
        this.icon               = 'i5-my-time'
        this.placeholder        = "Enter time"
        this.isSearchable       = false
        this.isFilterAvailable  = true

        this.conditionTypes     = FIELD_CONDITIONS_NUMBER

        this.clearButton        = _.get(config,'clearButton',true);

        this.components.PopoverMenu             = FieldTimeSpent_Popover
        this.components.PickerValueNotEmpty     = FieldTimeReported_PickerValueNotEmpty
        this.components.FormValueNotEmpty       = FieldTimeReported_FormValueNoteEmpty
        this.components.InlineValueEmpty        = FieldTimeReported_InlineValueEmpty
        this.components.InlineValueNotEmpty     = FieldTimeReported_InlineValueNotEmpty

        this.renderComponents.view              = FieldTimeSpent_View
        this.renderComponents.viewSmall         = FieldTimeSpent_ViewSmall
        this.renderComponents.glistView         = FieldTimeSpent_ViewSmall
        this.renderComponents.formElement       = FieldTimeSpent_FormElement
        this.renderComponents.picker            = FieldTimeSpent_Picker

        this.renderComponents.conditionForm     = FieldTimeSpent_ConditionForm
        this.renderComponents.filterForm        = FieldTimeSpent_ConditionForm

        this.filterFunc                         = FieldNumber_filterFunc
    }

    isValueValid(value:any):boolean {
        const intValue = _.toInteger(value)
        return (intValue>0)
    }

    sortValue(value:any) { return value ? value : 0; }


    getViewValue(model:any) {
        const value = _.get(model, this.fieldId, null)

        if (!value) return value

        return value
    }

    getDisplayValue(value:any) {
        if (!value) return value

        return minutesToHoursMinutesString(value)
    }
}
